/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileWordShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V22H8v-2h10V9h-5V4H6v4h5v9H8v-2h.476l1.078-4.87H8.522l-.683 3.242-.911-2.975h-.864l-.871 3.015-.69-3.283h-1.06L4.302 14H2V8h2zm11 3.414V7h1.586z" />
        <path d="M6 16v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236L1 16zm.472-4.276L7.166 14h-1.35z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileWordShortcut as FileWordShortcut };
